import { React, useState } from "react";
import SortedHeader from "../../components/Tables/SortedHeader";
import Pagination from "../../components/Pagination";
import moment from "moment";
import { toDateString } from "../../common/helper";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import IconThreeDots from "../../layout/others/three-dots.svg";
import ModalUndoHiring from "./ModalUndoHiring";
import { HiredCandidatesService } from "../../services/HiredCandidatesService";
import "./HiredCandidates.scss";
import { useGeneralContext } from "../General/Context";

export default function HiredCandidatesGrid({
  hiredCandidatesList,
  pageNumber,
  setPageNumber,
  isDataLoading,
  updateHiredCandidatesGrid,
  setUpdateHiredCandidateGrid,
  setPageSize,
  searchObject,
  setSearchObject,
  totalPages
}) {
  const { userInformation } = useGeneralContext();
  const { t } = useTranslation();
  const [headers, setHeaders] = useState([
    { label: t("Rating"), field: "Rating" },
    { label: t("Name"), field: "Name" },
    { label: t("Mobile number"), field: "PhoneNumber" },
    { label: t("Email Address"), field: "EmailAddress" },
    { label: t("Technical Area"), field: "TechArea" },
    { label: t("Technical Role"), field: "TechRole" },
    { label: t("Manager"), field: "ManagerName" },
    { label: t("Hired Date"), field: "Date", sorted: false },
    { label: "" }
  ]);
  const history = useHistory();

  const onClickViewInterview = (event, id) => {
    event.stopPropagation();
    history.push(`/interview/view/${id}`);
  };

  const [showModalUndoHiring, setShowModalUndoHiring] = useState(false);
  const [undoHiringCandidate, setUndoHiringCandidate] = useState({
    interviewId: 0,
    comment: ""
  });

  const openModal = (event, interviewId) => {
    event.stopPropagation();
    setUndoHiringCandidate({
      interviewId: interviewId
    });
    setShowModalUndoHiring(true);
  };

  const modalSubmitButton = () => {
    HiredCandidatesService.undoHiringCandidate(
      undoHiringCandidate.interviewId,
      undoHiringCandidate.comment
    ).then(() => {
      setShowModalUndoHiring(false);
      setUpdateHiredCandidateGrid(!updateHiredCandidatesGrid);
    });
  };

  return (
    <>
      <div className="table-wrap interview-list">
        {isDataLoading ? (
          <>
            <table>
              <thead>
                <SortedHeader
                  headers={headers}
                  setHeaders={setHeaders}
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                />
              </thead>
            </table>
          </>
        ) : (
          <>
            <table className="table-responsive">
              <thead className="col-md-24">
                <SortedHeader
                  setHeaders={setHeaders}
                  headers={headers}
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                />
              </thead>
              <tbody>
                {hiredCandidatesList.map((candidate) => {
                  return (
                    <tr
                      key={candidate.id}
                      onClick={(event) => {
                        onClickViewInterview(event, candidate.id);
                      }}
                    >
                      <td className={`rating text-truncate`}>
                        {candidate.rating}
                      </td>
                      <td className="name text-truncate" title={candidate.name}>
                        {candidate.name}
                      </td>
                      <td
                        className="phone text-truncate"
                        title={candidate.phoneNumber}
                      >
                        {candidate.phoneNumber}
                      </td>
                      <td
                        className="email text-truncate"
                        title={candidate.emailAddress}
                      >
                        {candidate.emailAddress}
                      </td>
                      <td
                        className="role text-truncate"
                        title={candidate.techArea}
                      >
                        {t(candidate.techArea)}
                      </td>
                      <td
                        className="role text-truncate"
                        title={candidate.techRole}
                      >
                        {t(candidate.techRole)}
                      </td>
                      <td
                        className="manager text-truncate"
                        title={candidate.managerName}
                      >
                        {t(candidate.managerName)}
                      </td>
                      <td
                        className="date text-truncate"
                        title={
                          candidate.date &&
                          moment(candidate.date).format("DD-MM-YYYY")
                        }
                        id="date"
                      >
                        {toDateString(candidate.date)}
                      </td>
                      <td style={{ display: "flex", flexDirection: "row" }}>
                        <div className="dropdown">
                          {userInformation.permissions
                            ?.Hired_Candidates_Undo && (
                            <>
                              {" "}
                              <button
                                className="action-button"
                                type="button"
                                id="options"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <img
                                  src={IconThreeDots}
                                  alt="threedots"
                                  title={t("Options")}
                                />
                              </button>{" "}
                              <ul
                                className="dropdown-menu"
                                aria-labelledby="more"
                              >
                                <li>
                                  <a
                                    href="#!"
                                    className="dropdown-item"
                                    onClick={(event) => {
                                      openModal(event, candidate.id);
                                    }}
                                    title={t("Undo hiring")}
                                    data-bs-toggle="tooltip"
                                  >
                                    {t("Undo hiring")}
                                  </a>
                                </li>
                              </ul>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {hiredCandidatesList.length === 0 && (
              <div className="table-message">
                {t("No Hired Candidates found.")}
              </div>
            )}
          </>
        )}
      </div>
      <div className="row">
        <div className="text-end">
          <Pagination
            totalPages={totalPages}
            setPageNumber={setPageNumber}
            pageNumber={pageNumber}
            setPageSize={setPageSize}
          />
        </div>
      </div>
      <ModalUndoHiring
        showModal={showModalUndoHiring}
        setShowModal={setShowModalUndoHiring}
        undoHiringCandidate={undoHiringCandidate}
        setUndoHiringCandidate={setUndoHiringCandidate}
        submitButton={modalSubmitButton}
      />
    </>
  );
}
